const $ = window.jQuery;

$(document).ready(function() {
    $(function() {
        var names;
        // files are added to file input
        $(".ginput_container_fileupload input[type='file']").change(function() {
            // get files
            var files = $(this).prop("files");
            // get filenames
            names = $.map(files, function(val) { return val.name + " "; });
            // display filenames
            $('.custom-filename').remove();
            for (var i = 0; i < names.length; i++) {
                $(this).closest('.ginput_container_fileupload').append('<span class="custom-filename">'+names+'</span>')
            }
        });
    });
});